<template>
  <div class="mt-12 flex flex-col justify-center">
    <div class="flex items-center mb-2 justify-between">
      <h4 class="cb-text-h5">Insights Overview</h4>


    </div>

    <div class="flex w-full justify-between items-start">
      <div class="filters flex gap-4 mb-2">

        <div class="form-control w-[168px]">
          <div class="relative">
            <button class="select-button !m-0" aria-haspopup="listbox" aria-expanded="true" aria-labelledby="listbox-label">
              <span class="w-full inline-flex truncate">
                <span class="select-secondary-text">Period:</span>
                <span class="truncate ml-1 black font-medium"> Custom </span>
              </span>
              <span class="select-button-icon-container">
                <!-- Heroicon name: solid/selector -->
                <svg class="h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                  aria-hidden="true">
                  <path fill-rule="evenodd"
                    d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z"
                    clip-rule="evenodd" />
                </svg>
              </span>
            </button>
          </div>
        </div>

        <div class="form-control w-[168px]">
          <div class="relative">
            <button class="select-button !m-0" aria-haspopup="listbox" aria-expanded="true" aria-labelledby="listbox-label">
              <span class="w-full inline-flex truncate">
                <span class="truncate ml-1 black font-medium"> Aug 15 - Aug 19 </span>
              </span>
              <span class="select-button-icon-container">
                <!-- Heroicon name: solid/selector -->
                <svg class="h-4 w-4" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M2.49997 5.83333C2.49997 4.91286 3.24616 4.16667 4.16663 4.16667H15.8333C16.7538 4.16667 17.4999 4.91286 17.4999 5.83333V15.8333C17.4999 16.7538 16.7538 17.5 15.8333 17.5H4.16663C3.24616 17.5 2.49997 16.7538 2.49997 15.8333V5.83333Z"
                    fill="white" />
                  <path
                    d="M6.66663 5.83333V2.5M13.3333 5.83333V2.5M5.8333 9.16667H14.1666M4.16663 17.5H15.8333C16.7538 17.5 17.4999 16.7538 17.4999 15.8333V5.83333C17.4999 4.91286 16.7538 4.16667 15.8333 4.16667H4.16663C3.24616 4.16667 2.49997 4.91286 2.49997 5.83333V15.8333C2.49997 16.7538 3.24616 17.5 4.16663 17.5Z"
                    stroke="#64648C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>

              </span>
            </button>
          </div>
        </div>
      </div>

      <div>

        <div v-click-outside="onClickOutside" class="form-control !m-0 !w-auto">
          <div class="relative !w-auto">

            <button @click="showOptions = !showOptions" class="select-button !m-0" aria-haspopup="listbox" aria-expanded="true" aria-labelledby="listbox-label">
              <span class="w-full inline-flex truncate">
                <span class="truncate ml-1 black font-medium"> Manage Charts </span>
              </span>
              <span class="select-button-icon-container">
                <!-- Heroicon name: solid/selector -->
                <svg class="btn-trailing-icon mr-2 w-4 h-4" xmlns="http://www.w3.org/2000/svg" fill="none"
                viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M10.5 6h9.75M10.5 6a1.5 1.5 0 11-3 0m3 0a1.5 1.5 0 10-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 01-3 0m3 0a1.5 1.5 0 00-3 0m-9.75 0h9.75" />
              </svg>
              </span>
            </button>

            <Transition>
              <ul v-show="showOptions" tabindex="-1"
                class="select-ul right-0 !w-max py-3 px-3 justify-center h-max !max-h-fit " role="listbox"
                aria-labelledby="listbox-label" aria-activedescendant="listbox-optio n-3">

                <li class="w-full !px-0 !pb-2 mx-auto group flex gap-2" id="listbox-option-0" role="option">

                  <div class="flex w-full items-center justify-between">
                    <span class="flex w-full flex-grow flex-col items-end justify-end ">
                      <a href="#link" class="cb-text-copy-regular btn-link !no-underline">Show all charts</a>
                    </span>

                  </div>
                </li>

                <SwitchItem text="Gross Volume" active="true" />
                <SwitchItem text="Refunds" active="true" />
                <SwitchItem text="Payment Acceptance Rate" active="true" />
                <SwitchItem text="Settlements" active="true" />
                <SwitchItem text="Chargebacks" />
                <SwitchItem text="Inquiries" />
                <SwitchItem text="Total Active Customers" active="true" />
                <SwitchItem text="New Customers" active="true" />

              </ul>
            </Transition>
          </div>
        </div>
      </div>
    </div>


    <div class="flex flex-wrap  sm:-mx-px max-w-7xl self-center">
      <div class="w-1/3  sm:my-px sm:px-px">
        <InsigthCard title="Gross Volume" data="$523,251.78" />
      </div>

      <div class="w-1/3  sm:my-px sm:px-px">
        <!-- Column Content -->
        <InsigthCard title="Refunds" data="$2,251.00" />
      </div>

      <div class="w-1/3  sm:my-px sm:px-px">
        <!-- Column Content -->
        <InsigthCard title="Payment Acceptance Rate" data="89%" />
      </div>

      <div class="w-1/3  sm:my-px sm:px-px">
        <!-- Column Content -->
        <InsigthCard title="Chargeback Rate" data="5%" />
      </div>

      <div class="w-1/3  sm:my-px sm:px-px">
        <!-- Column Content -->
        <InsigthCard title="Chargebacks" data="100" />
      </div>

      <div class="w-1/3  sm:my-px sm:px-px">
        <!-- Column Content -->
        <InsigthCard title="Inquiries" data="3" />
      </div>

      <div class="w-1/3  sm:my-px sm:px-px">
        <!-- Column Content -->
        <InsigthCard title="Settlements" data="$501,101.00" />
      </div>

      <div class="w-1/3  sm:my-px sm:px-px">
        <!-- Column Content -->
        <InsigthCard title="Total Active Customers" data="52,251" />
      </div>

      <div class="w-1/3  sm:my-px sm:px-px">
        <!-- Column Content -->
        <InsigthCard title="New Customers" data="2,222" />
      </div>
    </div>
  </div>
</template>


<script>
import InsigthCard from "./InsightCard.vue";
import SwitchItem from "./SwitchItem.vue";
import vClickOutside from 'click-outside-vue3'


export default {
  name: "Insights",
  components: {
    InsigthCard,
    SwitchItem
  },
  data() {
    return {
      showOptions: false
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  methods: {
    onClickOutside() {
      this.showOptions = false
    }
  }
};
</script>